let url = "http://srm.eeka.info:8081/eeka-srm";
const testEnv = [
  "localhost",
  "10.7.121.122",
  "202.170.130.245"
  // "srmfo.snms.eekafashion.com.cn",
  // "srmft.snms.eekafashion.com.cn"
];
const hostname = window.location.hostname;
if (testEnv.includes(hostname)) {
  url = "http://202.170.130.245:8081/eeka-srm";
}
export default url;



// WEBPACK FOOTER //
// ./src/public/ajaxurl.js